import React, { useEffect } from 'react';
/* Helpers */
import { objectIsEmpty, addThousandSeparator, convertValueToLogarithmicBehaviour, convertValueFromLogarithmicBehaviour } from '../../../helpers/utils';
import { updateCurrentSimulation } from '../../../helpers/handleCurrentSimulationData';
import { setPaymentDataFromCurrentAmount } from '../../../helpers/handleSlidersConnection';
/* Redux */
import { useSelector, useDispatch } from 'react-redux';
import { setAmountSliderThunk, setPaymentSliderThunk, setTableRecapThunk, setCurrentSimulationThunk } from '../../../redux/actions/index';
/* CSS */
import './style.css';

export const Slider = ({ type, title, table}) => {
  const amount = useSelector(state => state.sliders.amount);
  const payment = useSelector(state => state.sliders.payment);
  
  const dispatch = useDispatch();
  const setAmountSlider = (amountOptions) => dispatch(setAmountSliderThunk(amountOptions));
  const setPaymentSlider = (paymentOptions) => dispatch(setPaymentSliderThunk(paymentOptions));
  const setTableRecap = (tableMainDataForCurrentAmount) => dispatch(setTableRecapThunk(tableMainDataForCurrentAmount));
  const setCurrentSimulation = (currentSimulationData) => dispatch(setCurrentSimulationThunk(currentSimulationData));
  
  const renderCurrentValue = () => {
    switch (type) {
      case 'amount': {
        return addThousandSeparator(amount.currentValue.shown) + " €";
      }
      case 'payment': {
        if (!objectIsEmpty(payment.frontLayer)) {
          // If "min = max" case, put in front a layer with the real current value
          const { currentValue } = payment.frontLayer;
          
          return addThousandSeparator(currentValue) + " €";
        }

        return addThousandSeparator(payment.currentValue.shown) + " €";
      }
      default:
        return "";
    }
  }
  
  const initializeAmountSlider = () => {
    window.$(".js-slider-amount").ionRangeSlider({
      skin: "big",
      min: amount.min,
      max: amount.max,
      from: amount.initialValue.real,
      step: 10,
      prettify_separator: ".",
      prettify: function(num) {
        return addThousandSeparator(
          convertValueToLogarithmicBehaviour({
            currentValue: num,
            min: amount.min,
            max: amount.max,
            step: 1000
          },
          5)
        );
      },
      postfix: " €",
    });

    window.$(".js-slider-amount").data("ionRangeSlider");
  };

  const initializePaymentSlider = () => {
    window.$(".js-slider-payment").ionRangeSlider({
      skin: "big",
      min: payment.min,
      max: payment.max,
      from: payment.initialValue.real,
      step: 1,
      prettify_separator: ".",
      prettify: function(num) {
        return addThousandSeparator(
          convertValueToLogarithmicBehaviour({
            currentValue: num,
            min: payment.min,
            max: payment.max,
            step: 5
          },
          5)
        );
      },
      postfix: " €",
    });

    window.$(".js-slider-payment").data("ionRangeSlider");
  }
  
  const reinitializeAmountSlider = function(amount, min, max) {
    if (window.$(".js-slider-amount")?.data("ionRangeSlider")) {
      window.$(".js-slider-amount").data("ionRangeSlider").destroy();
    }

    window.$(".js-slider-amount").ionRangeSlider({
      skin: "big",
      min: min,
      max: max,
      from: convertValueFromLogarithmicBehaviour({
        currentValue: amount.currentValue.shown,
        min: min,
        max: max,
        step: 10
      },
      5),
      step: 10,
      prettify_separator: ".",
      prettify: function(num) {
        return addThousandSeparator(
          convertValueToLogarithmicBehaviour({
            currentValue: num,
            min: min,
            max: max,
            step: 1000
          },
          5)
        );
      },
      postfix: " €",
      onChange: function(data) {
        const logarithmicCurrentValue = convertValueToLogarithmicBehaviour({
          currentValue: data.from,
          min: min,
          max: max,
          step: 1000
        },
        5);

        setAmountSlider({
          currentValue: {
            real: convertValueFromLogarithmicBehaviour({
              currentValue: logarithmicCurrentValue,
              min: min,
              max: max,
              step: 10
            },
            5),
            shown: logarithmicCurrentValue,
          },
          reinitialize: false,
        });

        setPaymentSlider({
          reinitialize: true,
        });
      },
      onFinish: function(data) {
        setAmountSlider({
          reinitialize: true,
        });

        setPaymentSlider({
          reinitialize: false,
        });
      }
    });

    window.$(".js-slider-amount").data("ionRangeSlider");
  }

  const reinitializePaymentSlider = function(table, logarithmicCurrentAmount, payment) {
    if (window.$(".js-slider-payment")?.data("ionRangeSlider")) {
      window.$(".js-slider-payment").data("ionRangeSlider").destroy();
    }

    setPaymentSlider({
      selector: null,
    }).then(function() {
      window.$(".js-slider-payment").ionRangeSlider({
        skin: "big",
        min: payment.min,
        max: payment.max,
        from: payment.currentValue.real,
        step: 1,
        prettify_separator: ".",
        prettify: function(num) {
          // If "min = max" case, put in front a layer with the real labels and current value
          if (!objectIsEmpty(payment.frontLayer)) {
            const { currentValue, min, max } = payment.frontLayer;
            const paymentMinLabel = document.querySelector('.payment-slider .irs-min');
            const paymentMaxLabel = document.querySelector('.payment-slider .irs-max');

            paymentMinLabel.textContent = `${min} €`;
            paymentMaxLabel.textContent = `${max} €`;

            return currentValue;
          }

          return addThousandSeparator(
            convertValueToLogarithmicBehaviour({
              currentValue: num,
              min: payment.min,
              max: payment.max,
              step: 5
            },
            5)
          );
        },
        postfix: " €",
        onChange: function(data) {
          const logarithmicCurrentValue = convertValueToLogarithmicBehaviour({
            currentValue: data.from,
            min: data.min,
            max: data.max,
            step: 5
          },
          5);

          updateCurrentSimulation({
            table,
            logarithmicCurrentAmount,
            logarithmicCurrentPayment: logarithmicCurrentValue,
            frontLayer: payment.frontLayer,
          },
          {
            setCurrentSimulation,
          });

          setAmountSlider({
            reinitialize: false,
          });

          setPaymentSlider({
            currentValue: {
              real: data.from,
              shown: logarithmicCurrentValue,
            },
          });
        },
        onFinish: function(data) {
          const logarithmicCurrentValue = convertValueToLogarithmicBehaviour({
            currentValue: data.from,
            min: data.min,
            max: data.max,
            step: 5
          },
          5);

          setPaymentSlider({
            currentValue: {
              real: data.from,
              shown: logarithmicCurrentValue,
            },
          });

          setAmountSlider({
            reinitialize: true,
          });
        },
        onUpdate: function(data) {
          const logarithmicCurrentValue = convertValueToLogarithmicBehaviour({
            currentValue: data.from,
            min: data.min,
            max: data.max,
            step: 5
          },
          5);

          updateCurrentSimulation({
            table,
            logarithmicCurrentAmount,
            logarithmicCurrentPayment: logarithmicCurrentValue,
            frontLayer: payment.frontLayer,
          },
          {
            setCurrentSimulation,
          });
        }
      });

      window.$(".js-slider-payment").data("ionRangeSlider");

      // It is used to keep the installment slider fixed at the correct position while moving the amount slider
      if (window.$(".js-slider-payment").data("ionRangeSlider")) {
        window.$(".js-slider-payment").data("ionRangeSlider").update({
          from: convertValueFromLogarithmicBehaviour({
            currentValue: payment.currentValue.shown,
            min: payment.min,
            max: payment.max,
            step: 1
          },
          5),
        });
      }
    });
  }

  /* Handle sliders initialization before table is loaded */

  useEffect(function() {
    if (type === "amount") {
      initializeAmountSlider();
    }
  }, []);

  useEffect(function() {
    if (type === "payment") {
      initializePaymentSlider();
    }
  }, []);

  /* Handle sliders reinitialization when the table is loaded */

  useEffect(function() {
    if (Array.isArray(table) && table.length && type === "amount") {
      const minTableAmount = Number(table[0].ImpRich);
      const maxTableAmount = Number(table[table.length - 1].ImpRich);
      
      reinitializeAmountSlider(amount, minTableAmount, maxTableAmount);

      // It is used to move the amount slider in the correct position when the table is loaded
      if (window.$(".js-slider-amount").data("ionRangeSlider")) {
        window.$(".js-slider-amount").data("ionRangeSlider").update({
          from: convertValueFromLogarithmicBehaviour({
            currentValue: amount.currentValue.shown,
            min: minTableAmount,
            max: maxTableAmount,
            step: 10
          },
          5),
        });
      }
    }
  }, [table]);

  useEffect(function() {
    if (Array.isArray(table) && table.length && type === "payment") {
      reinitializePaymentSlider(table, amount.currentValue.shown, payment);
    }
  }, [table]);

  /* Handle sliders reinitialization after the table is loaded */

  useEffect(function() {
    if (amount.reinitialize) {
      if (type === 'amount') {
        reinitializeAmountSlider(amount, amount.min, amount.max);
      }
    }
  }, [amount.reinitialize]);

  useEffect(function() {
    if (payment.reinitialize) {
      if (type === 'payment') {
        reinitializePaymentSlider(table, amount.currentValue.shown, payment);
      }
    }
  }, [payment.reinitialize, payment.min, payment.max]);

  /* Handle payment slider update when amount is changed */

  useEffect(function() {
    if (Array.isArray(table) && table.length) {
      setPaymentDataFromCurrentAmount({
        table,
        currentAmount: amount.currentValue.shown,
        payment
      }, {
        setTableRecap,
        setPaymentSlider,
      });
    }
  }, [amount.currentValue.shown]);
  
  return (
    <div className={`amount-scp ${type}-slider`}>
      <div className="loan-title-scp">{ title }</div>
      <div className="slider__current-value current-value">
        <div className="current-value__container">
          <p className="current-value__text">{ renderCurrentValue() }</p>
        </div>
      </div>
      <div className="amount-slider-scp">
        <input className={`slider js-slider-${ type }`} type="text" />
      </div>
    </div>
  );
}
